import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { FeatureService } from '../services/feature.service';

export function featureFlagGuard(featureFlag: string): CanMatchFn {
  return () => {
    const featureService = inject(FeatureService);
    return featureService.getFeatureActive(featureFlag);
  };
}
